// Copyright ©️ 2026 eVolve MEP, LLC

import React, { type ReactNode } from 'react';

import { Flex, MantineProvider } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const AuthBackground = React.lazy(() => import('../AuthBackground'));

type Props = {
  children: ReactNode;
};

/** The animated-background page shell shared by the login pages and the desktop sign-in page. */
export const AuthPageLayout = ({ children }: Props) => {
  const isVertical = useMediaQuery('(max-width: 1023px)', false, {
    getInitialValueInEffect: false,
  });

  return (
    <MantineProvider theme={{ primaryColor: 'indigo' }}>
      <Flex
        direction={isVertical ? 'column' : 'row-reverse'}
        style={{
          backgroundColor: 'white',
        }}
      >
        <AuthBackground isMobile={isVertical} />
        <Flex
          direction="row"
          align="center"
          justify="center"
          p="md"
          style={
            isVertical
              ? {
                  width: '100%',
                  // dvh, not vh: on phones 100vh is the URL-bar-collapsed viewport, so a
                  // vh-derived height overflows the visible area and makes the page scrollable.
                  minHeight: 'calc(100dvh - 120px)',
                }
              : {
                  width: '40%',
                  minHeight: 'calc(100dvh - 425px)',
                  maxWidth: '700px',
                }
          }
        >
          {children}
        </Flex>
      </Flex>
    </MantineProvider>
  );
};
